import { VerticalFlexbox } from "@src/shared/components/layout/Flexbox";

import { PatientsListV2 } from "../../../components/v2/PatientsList";

export function PatientsPageV2() {
  return (
    <VerticalFlexbox className="mx-auto min-h-full w-full max-w-[860px] bg-background px-[18px] pb-8 pt-4">
      <PatientsListV2 />
    </VerticalFlexbox>
  );
}
